<template>
  <div v-if="reload" style="width: 100%" class="flex common-form" ref="commonForm">
    <div class="common-form-list">
      <template v-for="item in slotNameList.slice(0, number)">
        <slot :name="item"></slot>
      </template>
    </div>
    <!--    <div-->
    <!--        @click.stop="() => {}"-->
    <!--        v-show="show && number !== slotNameList.length"-->
    <!--        class="search-from-detail" ref="searchDialog">-->
    <!--      <template v-for="item in slotNameList.slice(number)">-->
    <!--        <slot :name="item"></slot>-->
    <!--      </template>-->
    <!--      <div class="flex common-form-operator">-->
    <!--        <div @click="reset">Reset</div>-->
    <!--        <div @click="apply">Apply</div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div
        @click.stop="() => {}"
        class="common-form-more">
      <div class="flex common-form-out-btn">
        <div class="common-form-tip" v-if="number !== slotNameList.length">
          <span :class="['common-form-btn', show || changeNumber && number !== slotNameList.length ? 'isActive' : '']" @click.stop="showDialog" >{{name ? name :'More Filters'}}</span>
          <span class="common-form-number" @click.stop="showDialog" v-if="changeNumber">{{countOther?countOther:changeNumber}}</span>
        </div>
        <div @click="reset" v-show="showReset" :class="['common-form-reset', canReset ? 'common-allaw-reset' : '']">
          <div>CLEAR ALL</div>
        </div>
      </div>
      <div
          v-show="show && number !== slotNameList.length"
          class="search-from-detail" ref="searchDialog">
        <template v-for="item in slotNameList.slice(number)">
          <slot :name="item"></slot>
        </template>
        <!--              <div class="flex common-form-operator">-->
        <!--                <div @click="reset">Reset</div>-->
        <!--                <div @click="apply">Apply</div>-->
        <!--              </div>-->
      </div>
    </div>

  </div>
</template>
<script>
import {service} from "./_service";

export default {
  name: 'commonForm',
  props: {
    slotNameList: {
      type: Array,
      default: () => []
    },
   
    showReset: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      default: 'More Filters'
    },
    countOther:{
      type: Number,
      default: 0
    }
    // stopProps: {
    //   type: Array,
    //   default: () => []
    // },
  },
  data() {
    return {
      reload: true, // 在resize的时候，强制重渲染一边dom，使label-input的inject的方法重新执行，获取dialog中已修改的筛选项的条数
      maxWidth: 0,  // 本组件的宽度
      slotItemWidth: {}, // 初识时保存每个slot的宽度
      number: 0,  // 裸露在外部的slot的数量
      show: false, // 展示dialog的宽度
      dialogInputId: {}, // 保存每个slot的独立的slot的
      changeNumber: 0, // 一修改筛选项的条数
      occupyWidth: 0, // 裸露在外部的筛选项的总宽度
      moreFilterWidth: 140, // 默认的more filter的宽度
      resetWidth: 87,
      canReset: false,
      subId: null,
    }
  },
  provide() {
    return {
      handleChange: this.handleChange
    }
  },
  model: {
    event: 'getStopProps',
    prop: 'stopProps'
  },
  created() {
    this.number = this.slotNameList.length
  },
  beforeDestroy() {
    service.unsubscription(this.subId)
    this.subId = null
  },
  activated() {
    service.active(this.subId)
  },
  mounted() {
    this.subId = service.subscription({
      click: this.hideDialog,
      resize: this.reloadDom
    })
    this.$nextTick(() => {
      for(let i in this.$slots) {
        let item = this.$slots[i][0].elm
        if (item) {
          this.slotItemWidth[i] = item.clientWidth
        }
      }
      this.init()
    })
  },
  methods: {
    reloadDom() {
      let maxWidth = this.$refs.commonForm.clientWidth
      const currentSlotName = this.slotNameList[this.number]
      const currentWidth = this.slotItemWidth[currentSlotName] || 0
      const lineWidth = this.slotNameList.length - this.number > 1 ?
          this.occupyWidth + this.moreFilterWidth :
          this.occupyWidth
      const maxLineWidth = this.slotNameList.length - this.number > 0 ?
          this.occupyWidth + this.moreFilterWidth :
          this.occupyWidth
      if (maxWidth - lineWidth > currentWidth || maxWidth < maxLineWidth) {
        this.init()
        this.$nextTick(() => {
          this.reload = false
          this.$nextTick(() => {
            this.reload = true
            this.$nextTick(() => {
              this.computedNumber()
            })
          })
        })
      }
    },
    apply() {
      this.$emit('apply')
    },
    reset() {
      if (!this.canReset) return
      const list = this.number === this.slotNameList.length ? this.slotNameList : this.slotNameList.slice(this.number)
      console.log(list)
      this.$emit('reset', list)
    },
    handleChange(id, value) {
      this.dialogInputId[id] = value
      this.computedNumber()
    },
    computedNumber() {
      this.changeNumber = 0
      this.canReset = false
      for (let id in this.dialogInputId) {
        let node = document.getElementsByClassName(id)[0]
        if (this.$refs.searchDialog && this.$refs.searchDialog.contains(node)) {
          this.dialogInputId[id] && this.dialogInputId[id].length ? this.changeNumber ++ : ''
        }
        if(this.$refs.commonForm && this.$refs.commonForm.contains(node)) {
          this.dialogInputId[id] && this.dialogInputId[id].length ? this.canReset = true : ''
        }
        node = null
      }
    },
    init() {
      this.maxWidth = this.$refs.commonForm.clientWidth - this.moreFilterWidth
      let width = this.resetWidth
      for (let i = 0; i < this.slotNameList.length; i++) {
        const item = this.slotNameList[i]
        width += this.slotItemWidth[item]

        if (i == this.slotNameList.length - 1) {
          this.maxWidth = this.maxWidth + this.moreFilterWidth
        }
        if (width > this.maxWidth) {
          this.number = i
          width -= this.slotItemWidth[item]
          break
        }
        if (i + 1 === this.slotNameList.length && width < this.maxWidth) {
          this.number = i + 1
        }
        width += 16
      }
      let list = this.slotNameList.slice(this.number)
      this.$emit('getStopProps', list)
      this.occupyWidth = width
      this.dialogInputId = {}
    },
    showDialog() {
      if (this.show) {
        this.show = false
      } else {
        this.show = true
      }
    },
    hideDialog() {
      this.show = false
    }
  }
}
</script>
<style lang="scss" scoped>
.flex{
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.common-form{
  //position: relative;
  //background: red;

  /deep/ .el-form-item{
    margin-bottom: 0;
    // margin-right: 0;
  }
  /deep/ .el-range-separator{
    display: inline-block !important;
  }
  & > div{
    flex: none;
  }

  * {
    font-weight: 500;
  }
}

.common-form-list{
  @extend .flex;
  flex: none;
  //max-width: calc(100% - 136px);
  & > div{
    flex: none;
    margin-right: 16px;

    &:last-child{
      margin-right: 0;
    }
  }
}
.search-from-detail{
  background: #fff;
  position: absolute;
  top: 28px;
  left: 16px;
  //border: 1px solid #ccc;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
  z-index: 1000;
  padding: 0px 24px 24px 24px;
  border-radius: 4px;

  /deep/ {
    & > div{
      width: 208px !important;
      margin-top: 32px;
    }

    .el-form-item{
      margin-right: 0;
    }
  }
}
.common-form-more{
  position: relative;
  font-weight: 500;
}
.common-form-tip{
  font-size: 14px;
  margin-left: 16px;
  height: 20px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  .common-form-btn{
    color: #4C556C;
    padding-left: 22px;
    background: url("../images/icon-16-filter.svg") no-repeat;
    background-size: 16px 16px;
    background-position: left center;
  }

  .common-form-number{
    margin-left: 6px;
    height: 20px;
    width: 20px;
    text-align: center;
    line-height: 20px;
    //padding: 0 8px;
    background: rgba(0, 94, 233, 0.09);
    color: #4066d4;
    border-radius: 2px;
  }

  &.active {
    background-image: url("../images/icon-16-filter-hover.svg");
    color: #4066d4;
  }

  &:hover .common-form-btn{
    background-image: url("../images/icon-16-filter-hover.svg");
    color: #4066d4;
  }
  .isActive{
    background-image: url("../images/icon-16-filter-hover.svg");
    color: #4066d4;
  }
}
.common-form-operator{
  justify-content: space-between;
  & > div{
    width: 62px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    border-radius: 2px;
    cursor: pointer;

    &:last-child{
      background: #4066d4;
      color: #fff;
    }

    &:first-child{
      background: #dadce1;
      color: #4c556c;
      border: solid 1px #dadce1;
    }
  }
}

.common-form-out-btn{
  font-size: 14px;
}

.common-form-reset{
  cursor: not-allowed;
  margin-left: 24px;
  color: #b2b6c0;
  background: url("../images/icon-16-refresh.svg") no-repeat;
  padding-left: 22px;
  background-size: 16px 16px;
  background-position: left center;
}
.common-allaw-reset{
  cursor: pointer;
  color: #4c556c;
  background-image: url("../images/icon-reset-sel.svg");
}
</style>
